module.exports = __webpack_public_path__ + "img/apparatus4.33ca6f0b.jpg";